<template>
    <div class="root-dialog-container">
        <div class="modal">
            <div class="modal-content">
                <div class="content-container">
                    <div class="header">
                        <div class="title">UtterAccess</div>
                    </div>
                    <div class="content">
                        {{message}}
                    </div>
                    <div class="footer">
                        <div class="buttons">
                            <button id="modal-button-secondary" v-if="this.dialogType != 'alert'" @click="button2Click">{{button2Caption}}</button>
                            <button id="modal-button-primary" @click="button1Click">{{button1Caption}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

/*
const expectedOptions = {
    message: 'sometext,
    button1Caption: 'Ok',
    button2Caption: 'Cancel',
    type: 'alert',
    button1Callback: somefunction,
    button2Callback: somefunction,
    defaultButton: 1 //(not implemented yet)
}
*/

export default {
    data() {
        return {
            button1Caption: this.options.button1Caption,
            button2Caption: this.options.button2Caption,
            message: this.options.message,
            dialogType: this.options.dialogType
        }
    },
    props: ['options'],
    methods: {
        
        button1Click: function() { this.options.button1Callback(); },
        button2Click: function() { this.options.button2Callback(); },

        setFocus: function(focus) {
            var primary = document.getElementById('modal-button-primary');
            var secondary = document.getElementById('modal-button-secondary');
            if (!focus) primary.focus();
            if (focus) {
                switch (focus) {
                    case 'primary': primary.focus(); break;
                    case 'secondary': secondary.focus(); break;
                    default: primary.focus();
                }
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.setFocus(this.options.focus);
        });
    }
}
</script>

